

const chartPie = (id, text, data) =>{
    Highcharts.chart(id, {
        chart: {
            type: 'pie',
            backgroundColor: 'transparent'
        },
        title: {
            text: text
        },
        tooltip: {
            pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
        },
        accessibility: {
            point: {
                valueSuffix: '%'
            }
        },
        plotOptions: {
          pie: {
              allowPointSelect: true,
              cursor: 'pointer',
              dataLabels: {
                  enabled: true,
                  format: '{point.percentage:.1f} %'
              },
              showInLegend: true
          }
        },
        series: [{
          name: 'Persentase',
          colorByPoint: true,
          data: data
        }]
      });
}


module.exports = {
    chartPie : chartPie
}